import React, { useState } from 'react';

const WhatsHotCard = ({
  title,
  authors,
  abstract,
  totalVotes,
  onAdd,
  hasVoted,
  date,
  time_start,
  time_end,
  location,
}) => {
  const [isAbstractVisible, setIsAbstractVisible] = useState(false);


  const formattedDate = new Date(date).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });
  const formattedTime = `${time_start} - ${time_end}`;
  const toggleAbstractVisibility = () => setIsAbstractVisible(!isAbstractVisible);

  return (
    <div className="card">
      <div className="vote-info">
        <i className="fa-solid fa-fire"></i>
        <span>{totalVotes}</span>
      </div>
      <h2>{title}</h2>
      <p className="authors">{authors || 'No authors listed'}</p>
      <div className="event-details">
        <div className="event-time">
          <div>{formattedDate}</div>
          <div>{formattedTime}</div>
        </div>
        <div className="event-location">
          {location}
        </div>
      </div>
      <div className={`abstract-container ${isAbstractVisible ? 'visible' : ''}`}>
        <p className="abstract">{abstract || 'No abstract available'}</p>
      </div>
      <button onClick={toggleAbstractVisibility} className="toggle-abstract">
        {isAbstractVisible ? 'Hide Abstract' : 'Show Abstract'}
      </button>
      <div className="separator"></div>
      <div className="buttons">
        <div className="button-with-instruction" style={{ marginLeft: '-10px' }}>
          <button className="add" onClick={onAdd} style={{ marginLeft: '25px', marginBottom: '0px',marginTop: '-14px' }}>
              <i className="fas fa-plus"></i>
            </button>
        </div>
      </div>
    </div>
  );
};

export default WhatsHotCard;
